const INITIAL_STATE = {
  status: "PENDING",
  list: [],
  currentPage: 0,
  totalResults: 0
}

export default INITIAL_STATE
